/**
 * Quick action button used in the chat welcome screen.
 * Displays an icon alongside a label in an outline-styled button.
 */
import type { LucideIcon } from 'lucide-react'
import type { ReactNode } from 'react'

import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

export interface ChatWelcomeQuickActionProps {
  icon: LucideIcon
  label: string
  onClick: () => void
  className?: string
}

export const ChatWelcomeQuickAction: React.FC<ChatWelcomeQuickActionProps> = ({
  icon: Icon,
  label,
  onClick,
  className,
}): ReactNode => (
  <Button
    variant="outline"
    className={cn('chat-welcome-quick-action gap-2', className)}
    onClick={onClick}
  >
    <Icon className="size-4" />
    {label}
  </Button>
)

ChatWelcomeQuickAction.displayName = 'ChatWelcomeQuickAction'
